import React from 'react';

import DispensaryHeader from 'src/dispensary/components/dispensary-header';
import GlobalFooter from 'components/global-footer-rebrand';
import LayoutWithHeader from 'components/layouts/with-marketplace-header';
import { DesktopOnly, MobileOnly } from 'shared/components';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useOrderTypeTakeoverPrompt } from 'src/hooks/use-order-type-takeover-prompt';

import { LayoutWrapper } from './layout-wrapper';

export function DispensaryProductLayout({ children }) {
  const { dispensary } = useDispensary();
  useOrderTypeTakeoverPrompt();

  if (!dispensary) {
    return null;
  }

  return (
    <LayoutWrapper>
      <DesktopOnly display='block'>
        <LayoutWithHeader>
          <DispensaryHeader />
          {children}
        </LayoutWithHeader>
      </DesktopOnly>
      <MobileOnly display='block'>
        <LayoutWithHeader>{children}</LayoutWithHeader>
        <GlobalFooter />
      </MobileOnly>
    </LayoutWrapper>
  );
}
